import authentication from './authentication'
import customer from './customer'

export default {
  AUTHENTICATION: authentication,
  CUSTOMER: customer,
}
